import type { FetchUserBillingRoutine } from '../interfaces';
import { isNull } from 'lodash';

export interface CardItem {
  readonly brand: string;
  readonly exprYear?: string;
  readonly lastFour?: string;
  readonly exprMonth?: string;
}

export const getInitialCardsState = (): CardItem[] => [];

export default function cardsReducer(
  state: CardItem[],
  payload: FetchUserBillingRoutine['success']['data']
): CardItem[] {
  const { brand, expr_year, last_four, expr_month } = payload;
  return brand === null
    ? state
    : [
        {
          brand: brand,
          exprYear: !isNull(expr_year) ? expr_year.toString() : undefined,
          lastFour: !isNull(last_four) ? last_four.toString() : undefined,
          exprMonth: !isNull(expr_month) ? expr_month.toString() : undefined,
        },
      ];
}
